import { Layout } from "antd";
import styled from "styled-components";

export const StyledCartBtnContainer = styled.div`
    position: sticky;
    bottom: 10px;
    margin-top: 16px;
`;

export const MainContainer = styled(Layout)`
    width: 100%;
    padding: 0 16px 0 16px;
    overflow-y: auto;
`;

export const GoodsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;
